"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Locale = void 0;
let Locale = exports.Locale = /*#__PURE__*/function (Locale) {
  Locale["deDE"] = "de-DE";
  Locale["esES"] = "es-ES";
  Locale["enUS"] = "en-US";
  Locale["enGB"] = "en-GB";
  Locale["fiFI"] = "fi-FI";
  Locale["nlNL"] = "nl-NL";
  Locale["itIT"] = "it-IT";
  Locale["svSE"] = "sv-SE";
  Locale["nbNO"] = "nb-NO";
  Locale["ptPT"] = "pt-PT";
  Locale["daDK"] = "da-DK";
  Locale["frCA"] = "fr-CA";
  Locale["esUS"] = "es-US";
  Locale["enCA"] = "en-CA";
  Locale["nlBE"] = "nl-BE";
  Locale["enIE"] = "en-IE";
  Locale["frBE"] = "fr-BE";
  Locale["frFR"] = "fr-FR";
  Locale["frCH"] = "fr-CH";
  Locale["deAT"] = "de-AT";
  Locale["deCH"] = "de-CH";
  Locale["itCH"] = "it-CH";
  Locale["enAU"] = "en-AU";
  Locale["enNZ"] = "en-NZ";
  Locale["enSG"] = "en-SG";
  Locale["enIN"] = "en-IN";
  return Locale;
}({});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJMb2NhbGUiLCJleHBvcnRzIl0sInNvdXJjZXMiOlsiLi4vLi4vc3JjL3R5cGVzL2dlbmVyaWMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGVudW0gTG9jYWxlIHtcbiAgZGVERSA9IFwiZGUtREVcIixcbiAgZXNFUyA9IFwiZXMtRVNcIixcbiAgZW5VUyA9IFwiZW4tVVNcIixcbiAgZW5HQiA9IFwiZW4tR0JcIixcbiAgZmlGSSA9IFwiZmktRklcIixcbiAgbmxOTCA9IFwibmwtTkxcIixcbiAgaXRJVCA9IFwiaXQtSVRcIixcbiAgc3ZTRSA9IFwic3YtU0VcIixcbiAgbmJOTyA9IFwibmItTk9cIixcbiAgcHRQVCA9IFwicHQtUFRcIixcbiAgZGFESyA9IFwiZGEtREtcIixcbiAgZnJDQSA9IFwiZnItQ0FcIixcbiAgZXNVUyA9IFwiZXMtVVNcIixcbiAgZW5DQSA9IFwiZW4tQ0FcIixcbiAgbmxCRSA9IFwibmwtQkVcIixcbiAgZW5JRSA9IFwiZW4tSUVcIixcbiAgZnJCRSA9IFwiZnItQkVcIixcbiAgZnJGUiA9IFwiZnItRlJcIixcbiAgZnJDSCA9IFwiZnItQ0hcIixcbiAgZGVBVCA9IFwiZGUtQVRcIixcbiAgZGVDSCA9IFwiZGUtQ0hcIixcbiAgaXRDSCA9IFwiaXQtQ0hcIixcbiAgZW5BVSA9IFwiZW4tQVVcIixcbiAgZW5OWiA9IFwiZW4tTlpcIixcbiAgZW5TRyA9IFwiZW4tU0dcIixcbiAgZW5JTiA9IFwiZW4tSU5cIixcbn1cblxuZXhwb3J0IHR5cGUgVHJhY2tpbmdEYXRhID0ge1xuICBjYXRlZ29yeT86IHN0cmluZ1xuICBwYWdlTmFtZTogc3RyaW5nXG4gIHBhZ2VTZWN0aW9uOiBzdHJpbmdcbiAgcGFnZVN0YWdlOiBzdHJpbmdcbiAgcHJvZHVjdElkPzogc3RyaW5nXG4gIGNvcmVQcm9kdWN0SWQ/OiBzdHJpbmdcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0lBQVlBLE1BQU0sR0FBQUMsT0FBQSxDQUFBRCxNQUFBLDBCQUFOQSxNQUFNO0VBQU5BLE1BQU07RUFBTkEsTUFBTTtFQUFOQSxNQUFNO0VBQU5BLE1BQU07RUFBTkEsTUFBTTtFQUFOQSxNQUFNO0VBQU5BLE1BQU07RUFBTkEsTUFBTTtFQUFOQSxNQUFNO0VBQU5BLE1BQU07RUFBTkEsTUFBTTtFQUFOQSxNQUFNO0VBQU5BLE1BQU07RUFBTkEsTUFBTTtFQUFOQSxNQUFNO0VBQU5BLE1BQU07RUFBTkEsTUFBTTtFQUFOQSxNQUFNO0VBQU5BLE1BQU07RUFBTkEsTUFBTTtFQUFOQSxNQUFNO0VBQU5BLE1BQU07RUFBTkEsTUFBTTtFQUFOQSxNQUFNO0VBQU5BLE1BQU07RUFBTkEsTUFBTTtFQUFBLE9BQU5BLE1BQU07QUFBQSIsImlnbm9yZUxpc3QiOltdfQ==